import styled from '@emotion/styled';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { withConfig } from 'src/withConfig';

export const CardFooterListItem = withConfig(theme => styled('div', { label: 'CardFooterListItem' })`
    align-items: center;
    background: ${theme.star.selectionsGroup.bgColor};
    border-bottom: 1px solid ${theme.star.racingNextOff.raceBox.borderColor};
    display: flex;
    flex-flow: row nowrap;
    gap: 8px;
    height: 40px;
    padding: ${theme.star.padding.xMedium};
`);

export const ShowMoreLink = withConfig(theme => styled(Link, { label: 'ShowMoreLink' })`
    color: ${theme.star.racingNextOff.raceBox.txtColor};
    display: flex;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 4px;
    line-height: 1.3334;
    text-decoration: none;
    text-transform: capitalize;
`);

export const ShowMoreArrowWrapper = styled(ChevronIcon, { label: 'ShowMoreArrowWrapper' })`
    align-self: center;
    fill: currentcolor;
    position: relative;
    width: 12px;
`;

export const ShowMoreText = withConfig(theme => styled('div', { label: 'ShowMoreText' })`
    color: ${theme.star.racingNextOff.raceBox.txtColor};
    display: flex;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 4px;
    line-height: 1.3334;
    text-transform: capitalize;
`);

export const CardFooterListItemLink = withConfig(theme => styled(Link, { label: 'CardFooterListItemLink' })`
    align-items: center;
    background-color: ${theme.star.selectionsGroup.bgColor};
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding: ${theme.star.padding.medium} ${theme.star.padding.xMedium};
    height: 32px;
    border-radius: ${theme.star.radius.medium};
    text-decoration: none;
`);
